<template>
  <div>
    <b-card title="Send Express SMS 🚀">
      <b-card-text>
          <b-row>
          <b-col md="6">
          <b-form>
              <b-form-group
              label="Select Sender Name"
              label-for="sender-name"
            >
              <v-select
                v-model="composeData.sender"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="senders"
                :reduce="name => name.id"
                :clearable="false"
                @open="fetchSenders"
                input-id="sender-id"
                label="name"
              />
            </b-form-group>

            <b-form-group
              label="Phone Numbers"
              label-for="phone-numbers"
            >
              <b-form-tags
                v-model="composeData.to"
                input-id="phone-numbers"
                placeholder="Type in Phone number and Press Enter to add"
                class="mb-2"
              />
              <span> Recipients: {{ composeData.to }}</span>
              <span> Total Recipients: <b-badge variant="primary">{{ numOfContacts }}</b-badge></span>
            </b-form-group>
            <b-form-group
                  label="Message"
                  label-for="message"
                >
                  <b-form-textarea
                    ref="refMessage"
                    id="message"
                    v-model="composeData.message"
                    placeholder="Message"
                    rows="8"
                    no-resize
                  />
                  <div
                  v-if="composeData.message!==undefined && composeData.message.length>0"
                  >
                    <b-alert show
                    class="mt-2 mb-2"
                    variant="dark"
                    >
                     <p class="m-2 mt-2 mb-2"> <small> Message Length: Includes <strong>STOP *456*9*5#</strong> Suffix</small>
                      <b-badge variant="secondary" class="ml-1">{{composeData.message.length + 14}}</b-badge>
                     </p>

                     </b-alert>
                  </div>
                </b-form-group>
            <b-button
            variant="primary"
            type="button"
            @click="submitForm"
            >
                Send
            </b-button>
          </b-form>
          </b-col>
          </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  ref,
  onUnmounted,
  computed,
} from '@vue/composition-api'

import {
  BCard,
  BCardText,
  BFormTextarea,
  BFormTags,
  BForm,
  BFormGroup,
  BBadge,
  BCol,
  BRow,
  BButton,
  BAlert,
} from 'bootstrap-vue'
// Notification
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import vSelect from 'vue-select'
import store from '@/store'
import axios from '@axios'
import router from '@/router'
import outBoxStoreModule from '../outBoxStoreModule'

export default {
  components: {
    BCard,
    BCardText,
    BFormTextarea,
    BFormTags,
    BForm,
    BFormGroup,
    BBadge,
    BButton,
    BAlert,
    vSelect,
    BCol,
    BRow,
  },
  setup() {
    const OUTBOX_STORE_MODULE_NAME = 'outbox'

    // Register module
    if (!store.hasModule(OUTBOX_STORE_MODULE_NAME)) store.registerModule(OUTBOX_STORE_MODULE_NAME, outBoxStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(OUTBOX_STORE_MODULE_NAME)) store.unregisterModule(OUTBOX_STORE_MODULE_NAME)
    })
    const toast = useToast()
    const blankComposeData = {
      sender: '',
      message: '',
      to: [],
    }
    const senders = ref([])
    const recipientsList = ref([])
    const membership = JSON.parse(JSON.stringify(Vue.$cookies.get('userData').membership))
    const composeData = ref(JSON.parse(JSON.stringify(blankComposeData)))
    const resetComposeData = () => {
      composeData.value = JSON.parse(JSON.stringify(blankComposeData))
    }
    const fetchSenders = () => {
      store
        .dispatch('outbox/fetchOrganisationSenders', {
          orgId: membership.organisation_id,
          is_active: true,
        })
        .then(response => {
          const { results } = response.data
          senders.value = results
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error fetching senders' list",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
    const submitForm = () => {
      composeData.value.to.forEach(item => {
        const recipientObj = { recipient: item }
        recipientsList.value.push(
          recipientObj,
        )
      })
      const postData = {
        message: composeData.value.message,
        recipients: JSON.parse(JSON.stringify(recipientsList.value)),
        sender_id: composeData.value.sender,
        org_id: membership.organisation_id,
      }
      console.log('Post Data', postData)
      axios.post('/outbox/create-express', postData).then(res => {
        console.log(res.data)
        resetComposeData()
        router.push({ name: 'outbox' })
      })
        .catch(res => {
          console.log('ERROR OCCURED', res)
        })
    }
    // eslint-disable-next-line arrow-body-style
    const estimateUnits = computed(() => {
      if (composeData.value.to.length > 0 && composeData.value.to !== undefined) {
        const msgLength = composeData.value.message.length + 14
        return composeData.value.to.reduce((tt, to) => tt + to.length, 0) * (Math.ceil(msgLength / 160))
      }
      return 0
    })
    const numOfContacts = computed(() => {
      if (composeData.value.to.length > 0 && composeData.value.to !== undefined) {
        return composeData.value.to.length
      }
      return 0
    })
    return {
      composeData,
      resetComposeData,
      senders,
      fetchSenders,
      estimateUnits,
      numOfContacts,
      submitForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#sender-id {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
